import React from 'react';
import sumBy from 'lodash/sumBy';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import CheckboxGroup from '../CheckboxGroup/CheckboxGroup';
import FilterOptionChecks from '../FilterOptionChecks/FilterOptionChecks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-pro-light/faAngleDown';
import './MobileFilterOptions.css';

function calculateCount(filters) {
  return sumBy(filters, (f) => (f.checked === true ? 1 : 0));
}

function calculateInstitutionCount(institutions) {
  const institutionsWithoutHeaders = institutions.slice(3);
  return institutionsWithoutHeaders.length > 0
    ? sumBy(institutionsWithoutHeaders, (f) => (f.checked === true ? 1 : 0))
    : 0;
}

const MobileFilterOptions = ({
  filterOptions,
  filterCheckHandler,
  institutions,
  handleInstitutionCheckBoxClick,
  filterCephAccredited,
  filterCephApplicant,
  headerCount,
}) => (
  <Accordion>
    {/* Institutions Section */}
    <AccordionItem key="institutions">
      <AccordionItemHeading
        children={
          <AccordionItemButton
            children={
              <div className="accordion__buttonInner">
                <span className="accordion__title">
                  Institution
                  {calculateInstitutionCount(institutions) > 0 && (
                    <span className="FilterOptionButton--count">
                      ({calculateInstitutionCount(institutions)})
                    </span>
                  )}
                </span>
                <span className="accordion__chevron" aria-hidden="true">
                  <FontAwesomeIcon icon={faAngleDown} />
                </span>
              </div>
            }
          />
        }
      />

      <AccordionItemPanel>
        <fieldset>
          {institutions.map((p, index) => (
            <CheckboxGroup
              accredited={p.accredited}
              key={p.name}
              name={p.name}
              index={index}
              checkHandler={handleInstitutionCheckBoxClick}
              checked={p.checked}
              justify={!!p.justify}
              filterCephAccredited={filterCephAccredited}
              filterCephApplicant={filterCephApplicant}
              header={p.header}
              headerCount={headerCount}
            />
          ))}
        </fieldset>
      </AccordionItemPanel>
    </AccordionItem>

    {/* Dynamic filter options */}
    {filterOptions.map((filterOption, index) => {
      const count = calculateCount(filterOption.filters);

      return (
        <AccordionItem key={filterOption.name}>
          <AccordionItemHeading
            children={
              <AccordionItemButton
                children={
                  <div className="accordion__buttonInner">
                    <span className="accordion__title">
                      {filterOption.name}
                      {count > 0 && <span className="FilterOptionButton--count">({count})</span>}
                    </span>
                    <span className="accordion__chevron" aria-hidden="true">
                      <FontAwesomeIcon icon={faAngleDown} />
                    </span>
                  </div>
                }
              />
            }
          />
          <AccordionItemPanel>
            <FilterOptionChecks
              filterCheckHandler={filterCheckHandler}
              key={index}
              index={index}
              active
              filters={filterOption.filters}
            />
          </AccordionItemPanel>
        </AccordionItem>
      );
    })}
  </Accordion>
);

export default MobileFilterOptions;
